import config from '@packages/config';
import type { LocalizedPath } from '@packages/config/src/default/types';
import type { CheckoutPage } from '@packages/gql/generated/shopping/graphql';

export type CheckoutPages = {
  [key in CheckoutPage]: LocalizedPath;
};

export const checkoutPathByPage: CheckoutPages = {
  LoginPage: config.order.paths.login,
  CheckAndOrder: config.order.paths.checkandorder,
};
